(function () {
  'use strict';

  function init(container) {
    var entries = container.querySelectorAll('.wb-subtitle.wb-anim-entry');
    if (!entries.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      entries.forEach(function (el) { el.classList.add('none'); });
      return;
    }

    var observer = new IntersectionObserver(function (items) {
      items.forEach(function (item) {
        if (item.isIntersecting) {
          item.target.classList.add('in-view');
          observer.unobserve(item.target);
        }
      });
    }, { threshold: 0.2 });

    entries.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

})();